/*--------------------------------
動画の自動再生（functions.php の tant_video で出力した video[data-autoplay]）

画面に入っている間だけ再生し、外に出たら止める。
OS の「視差効果を減らす」設定では自動再生しない（poster か 1 フレーム目を表示）。
--------------------------------*/

export function autoplayVideos() {
	const videos = document.querySelectorAll('video[data-autoplay]');
	if (!videos.length) return;

	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

	const io = new IntersectionObserver((entries) => {
		entries.forEach(({ target, isIntersecting }) => {
			if (isIntersecting) {
				target.play().catch(() => {});
			} else {
				target.pause();
			}
		});
	});

	videos.forEach((video) => io.observe(video));
}
